import { render } from "./EduTreeManager.vue?vue&type=template&id=202f99a0"
import script from "./EduTreeManager.vue?vue&type=script&lang=js"
export * from "./EduTreeManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__